
import { useNavigate } from 'react-router-dom';
import Button from '../base/Button';

export default function AccommodationSection() {
  const navigate = useNavigate();

  const accommodations = [
    {
      title: 'Habitaciones',
      description: 'Comodidad y privacidad con baño privado, baño compartido, aire acondicionado (en algunas habitaciones), Ventilador (en algunas habitaciones).',
      features: ['Desayuno', 'WiFi', 'Piscina'],
      image: 'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/9c1c2bb9c344838fd0b6b35251a082ec.jpeg',
      route: '/habitaciones'
    },
    {
      title: 'Carpas',
      description: 'Inmersión segura en la naturaleza con todas las comodidades básicas.',
      features: ['Desayuno', 'WiFi', 'Piscina', 'Baño compartido'],
      image: 'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/ec226f5e87a18141b5f0c4183beb31b4.png',
      route: '/carpas'
    },
    {
      title: 'Hamacas',
      description: 'Experiencia rústica auténtica',
      features: ['Desayuno', 'WiFi', 'Conexión natural'],
      image: 'https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/b5d174a064fe8165f9ca994ed1b51cb9.png',
      route: '/hamacas'
    }
  ];

  const handleViewDetails = (route: string) => {
    window.scrollTo(0, 0);
    navigate(route);
  };

  return (
    <section id="alojamiento" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            Acomodaciones
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Elige la experiencia perfecta para tu estadía en el paraíso
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {accommodations.map((accommodation, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img 
                  src={accommodation.image}
                  alt={accommodation.title}
                  className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  {accommodation.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {accommodation.description}
                </p>
                
                <div className="mb-6 flex-grow">
                  <h4 className="font-semibold text-gray-800 mb-2">Incluye:</h4>
                  <ul className="space-y-1">
                    {accommodation.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-gray-600">
                        <i className="ri-check-line text-teal-600 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <Button 
                  variant="primary" 
                  className="w-full mt-auto"
                  onClick={() => handleViewDetails(accommodation.route)}
                >
                  Ver Detalles
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
